<template>
    <div class="index h-full" :style="{ paddingBottom: tabHeight + 'px' }">
        <van-loading v-if="isLoading" color="#1989fa" style="
                position: fixed;
                top: 15%;
                left: 50%;
                transform: translate(-50%, -50%);
            " />
        <template v-else>
            <div v-if="periods.length" class="w-full h-full layout-side course">
                <div class="h-full course-l">
                    <div class="w-full course-l-item" :class="[
                        selectedItem.train_id === p.train_id
                            ? 'course-l-item-selected'
                            : '',
                    ]" v-for="(p, index) in periods" :key="'periods_' + index" @click="onActivePeriods(p)">
                        {{ p.course_name }}
                    </div>
                </div>
                <div class="h-full course-r pc-grid">
                    <div class="edit-time" v-if="
                        is_recharge_type == 1 &&
                        selectedItem &&
                        userDatalt.isDealer
                    ">
                        <div class="edit-time-header">
                            <div class="edit-time-title">
                                {{ selectedItem.course_name }}
                            </div>
                            <div class="edit-time-actions">
                                <div class="lesson-edit" @click="toggleEdit" v-if="!isEditing">
                                    编辑
                                </div>
                                <div class="lesson-edit" @click="submitEdit" v-else>
                                    完成
                                </div>
                                <div class="lesson-cancel" v-if="isEditing" @click="cancelEdit">
                                    取消
                                </div>
                            </div>
                        </div>
                        <template v-if="!isEditing">
                            <div class="edit-time-item">
                                <span class="time-label">开始时间：</span>
                                <span class="time-value">{{
                                    currentStartTime || "未设置"
                                    }}</span>
                            </div>
                            <div class="edit-time-item">
                                <span class="time-label">结束时间：</span>
                                <span class="time-value">{{
                                    currentEndTime || "未设置"
                                    }}</span>
                            </div>
                            <div class="edit-time-item">
                                <span class="time-label">红包金额：</span>
                                <span class="time-value">{{
                                    currentMoney || "未设置"
                                    }}</span>
                            </div>
                        </template>
                        <template v-else>
                            <!-- 开始时间 -->
                            <div class="edit-time-item">
                                <span class="time-label">开始时间：</span>
                                <div class="time-input-wrapper">
                                    <van-field v-model="editForm.start_time" readonly placeholder="请选择开始时间"
                                        @click="showStartTimePicker = true" class="time-input" />
                                    <time-picker v-model="showStartTimePicker" title="选择开始时间"
                                        :default-time="startTimeDate" @confirm="onStartTimeConfirm"
                                        @cancel="showStartTimePicker = false" />
                                </div>
                            </div>
                            <!-- 结束时间 -->
                            <div class="edit-time-item">
                                <span class="time-label">结束时间：</span>
                                <div class="time-input-wrapper">
                                    <van-field v-model="editForm.end_time" readonly placeholder="请选择结束时间"
                                        @click="showEndTimePicker = true" class="time-input" />
                                    <time-picker v-model="showEndTimePicker" title="选择结束时间" :default-time="endTimeDate"
                                        @confirm="onEndTimeConfirm" @cancel="showEndTimePicker = false" />
                                </div>
                            </div>
                            <!-- 红包金额 -->
                            <div class="edit-time-item">
                                <span class="time-label">红包金额：</span>
                                <div class="time-input-wrapper">
                                    <van-field
                                        v-model="editForm.red_money"
                                        type="number"
                                        placeholder="请输入红包金额"
                                        class="time-input"
                                    />
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="course-r-item w-full layout-side pc-col" v-for="(c, index) in courses"
                        :key="'course_' + index" style="height: auto">
                        <div class="es-block" style="
                                border-radius: var(--base-px-8);
                                color: white;
                                width: 100%;
                            " @click="
                                routerPush(
                                    '/course/details?id=' +
                                    c.lesson_id +
                                    '&train_lesson_id=' +
                                    c.train_lesson_id
                                )
                                ">
                            <div style="padding-top: 57.8%"></div>
                            <div class="">
                                <img :src="c.image" style="width: 100%; height: 100%" />

                                <div class="es es-ver" style="
                                        position: absolute;
                                        left: 0;
                                        top: 0;
                                        width: 100%;
                                        height: 100%;
                                        background: rgba(0, 0, 0, 0.2);
                                    ">
                                    <div class="es-omit" style="
                                            font-size: var(--base-px-13);
                                            font-weight: 500;
                                            margin-left: var(--base-px-8);
                                            font-weight: 600;
                                            margin-top: 8px;
                                        ">
                                        {{ c.title }}
                                    </div>
                                    <div class="es-f1"></div>
                                    <div style="
                                            font-size: var(--base-px-11);
                                            margin-left: var(--base-px-8);
                                            margin-bottom: 6px;
                                            line-height: var(--base-px-16);
                                        ">
                                        <div>开始时间：{{ c.start_time }}</div>
                                        <div style="margin-top: var(--base-px-2)">
                                            结束时间：{{ c.end_time }}
                                        </div>
                                    </div>
                                </div>
                                <div class="es es-ac es-pc" style="
                                        position: absolute;
                                        left: 0;
                                        top: 0;
                                        width: 100%;
                                        height: 100%;
                                    ">
                                    <img style="
                                            width: var(--base-px-36);
                                            height: var(--base-px-36);
                                            border-radius: 0;
                                        " src="../../assets/course/play.png" />
                                </div>
                            </div>
                        </div>
                        <div class="es es-ac" style="
                                width: 100%;
                                padding-top: var(--base-px-12);
                                font-size: var(--base-px-13);
                                padding-bottom: var(--base-px-2);
                            ">
                            <div>时长：{{ c.times }}</div>
                            <div class="es-f1"></div>
                            <div class="layout-right-center" @click.stop="onData(c)" style="
                                    font-size: var(--base-px-12);
                                    color: #1a89f9;
                                " v-if="!userDatalt.isDealer">
                                <img style="
                                        width: var(--base-px-12);
                                        height: var(--base-px-12);
                                        margin-right: var(--base-px-4);
                                        margin-top: var(--base-px-2);
                                    " src="../../assets/course/tj40.png" /><span>数据统计</span>
                            </div>
                            <div class="es-f1"></div>
                            <div class="layout-right-center" @click.stop="onShare(c)" style="
                                    font-size: var(--base-px-12);
                                    color: #1a89f9;
                                    margin-left: var(--base-px-5);
                                " v-if="!userDatalt.isDealer">
                                <img style="
                                        width: var(--base-px-10);
                                        height: var(--base-px-10);
                                        margin-right: var(--base-px-4);
                                        margin-top: var(--base-px-2);
                                    " src="../../assets/course/2.png" /><span>分享</span>
                            </div>
                            <!-- 新增：创建下载任务按钮 -->
                            <div class="layout-right-center" @click.stop="
                                ScrmQunguanExportTrainLessonStatistics(c)
                                " style="
                                    font-size: var(--base-px-12);
                                    color: #1a89f9;
                                    margin-left: var(--base-px-5);
                                " v-if="userDatalt.isDealer">
                                <img style="
                                        width: var(--base-px-10);
                                        height: var(--base-px-10);
                                        margin-right: var(--base-px-4);
                                        margin-top: var(--base-px-2);
                                    " src="../../assets/up.png" /><span>下载报表</span>
                            </div>
                        </div>
                        <!-- <div class="es es-ac" style="
                                width: 100%;
                                padding-top: var(--base-px-12);
                                font-size: var(--base-px-13);
                                padding-bottom: var(--base-px-2);
                            ">
                            <div class="layout-right-center" @click.stop="
                                viewCoupon(c)
                                " style="
                                    font-size: var(--base-px-12);
                                    color: #1a89f9;
                                    margin-left: var(--base-px-5);
                                ">
                                <span>查看优惠券</span>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            <van-empty v-else description="暂无数据" />
        </template>

        <IndexModel v-if="data_model" :data="data_model" :train_lesson_id="train_lesson_id"
            v-on:close="data_model = false">
        </IndexModel>

        <!-- 课程分享组件 -->
        <CourseShare ref="courseShareRef" :userInfo="userDatalt" :showRobot="is_robot" />
        <van-tabbar id="tabbar" v-model="active" class="tab">
            <van-tabbar-item replace to="/">
                <span>首页</span>
                <template #icon="props">
                    <img v-if="props.active" src="../../assets/images/home.png" />
                    <img v-else src="../../assets/images/home-active.png" />
                </template>
            </van-tabbar-item>
            <van-tabbar-item replace to="/course/index" icon="search">
                <span>课程</span>
                <template #icon="props">
                    <img v-if="props.active" src="../../assets/images/course-active.png" />
                    <img v-else src="../../assets/images/course.png" />
                </template>
            </van-tabbar-item>
            <van-tabbar-item replace to="/contact/index" icon="search">
                <span>客户</span>
                <template #icon="props">
                    <img v-if="props.active" src="../../assets/images/customer-active.png" />
                    <img v-else src="../../assets/images/customer.png" />
                </template>
            </van-tabbar-item>
            <!--			<van-tabbar-item replace to="/tool/index" icon="setting-o">-->
            <!--				<span>运营工具</span>-->
            <!--				<template #icon="props">-->
            <!--					<img v-if="props.active" src="../../assets/images/function-active.png"/>-->
            <!--					<img v-else src="../../assets/images/function.png">-->
            <!--				</template>-->
            <!--			</van-tabbar-item>-->
            <van-tabbar-item replace :to="userDatalt.isDealer ? '/my' : '/my?id=' + userDatalt.id" icon="setting-o">
                <span>{{ userDatalt.isDealer ? "我的" : "直播课" }}</span>
                <template #icon="props">
                    <img v-if="props.active" src="../../assets/images/my-active.png" />
                    <img v-else src="../../assets/images/my.png" />
                </template>
            </van-tabbar-item>
            <van-tabbar-item v-if="!userDatalt.isDealer && is_live" replace to="/live/index" icon="search">
                <span>直播</span>
                <template #icon="props">
                    <img v-if="props.active" src="../../assets/images/live-active.png" />
                    <img v-else src="../../assets/images/live.png" />
                </template>
            </van-tabbar-item>
        </van-tabbar>
        <van-overlay :show="show">
            <div class="wrapper">
                <div class="block">
                    <div class="layout-center">
                        <van-loading color="#1989fa" />
                    </div>
                    分享链接生成中，请等待
                </div>
            </div>
        </van-overlay>
    </div>
</template>
<script>
import StatisticsPage from "@/views/index/components/statisticsPage.vue";
import {
    courseList,
    courseLessonList,
    trainLessonDataStatistics,
    trainLessonJoinLogList,
    ScrmQunguanExportTrainLessonStatistics,
    updateTrainTimeRedMoneyConfig,
    getTrainTimeRedMoneyConfig
} from "@/api/course";
import { userCenter } from "@/api/homePage";
import CourseShare from "@/components/CourseShare/index.vue";

import IndexModel from "./indexModel.vue";
import {
    sendChatMessage,
    shareToExternalMoments,
} from "../../utils/wxCodeAuth";
import { message } from "ant-design-vue";
import { Toast } from "vant";
import TimePicker from "@/components/timePicker/index.vue";

export default {
    components: { StatisticsPage, IndexModel, TimePicker, CourseShare },
    data() {
        return {
            text: "http://www.baidu.com&" + Math.round(Math.random() * 10),
            tabHeight: 0,
            // tab 切换
            active: 1,
            selectedItem: { id: "" },
            periods: [],
            courses: [],
            userDatalt: {
                name: "",
            },
            show: false,

            data_model: false,
            train_lesson_id: "",
            isLoading: false,
            is_live: process.env.VUE_APP_IS_LIVE === "false" ? false : true,
            is_robot: process.env.VUE_APP_IS_ROBOT === "false" ? false : true,
            is_recharge_type: process.env.VUE_APP_IS_RECHARGE_TYPE,
            // 编辑时间相关
            isEditing: false,
            editForm: {
                start_time: "",
                end_time: "",
            },
            showStartTimePicker: false,
            showEndTimePicker: false,
            startTimeDate: "00:00:00",
            endTimeDate: "00:00:00",
            currentStartTime: "",
            currentEndTime: "",
            currentTrainLessonId: null,
        };
    },
    created() {
        this.userDetails();
        courseList().then((res) => {
            this.isLoading = false;
            this.periods = res.data;
            this.selectedItem = this.periods[0];
            if (this.selectedItem) {
                this.getTrainTimeRedConfig(this.selectedItem.train_id)
                this.getCourseLessonList(this.selectedItem.train_id);
            }
        });
    },
    mounted() {
        const tabbarDIV = document.getElementById("tabbar");
        this.tabHeight = tabbarDIV.clientHeight + 12;
    },
    methods: {
        getTrainTimeRedConfig(train_id){
            getTrainTimeRedMoneyConfig({
                train_id
            }).then((res)=>{
                if(res.code==1){
                    this.currentEndTime = res.data.train_end_time
                    this.currentStartTime = res.data.train_start_time
                    this.currentMoney = res.data.train_red_money
                }
            })
        },
        viewCoupon(item) {
            let data = {
                train_lesson_id: item.train_lesson_id,
            }
            if (this.userDatalt.isDealer) {
                data.tenant_id = this.userDatalt.id
            } else {
                data.employee_id = this.userDatalt.id
            }
            this.$router.push({
                path: '/my/coupon',
                query: data
            });
        },
        async onShare(item) {
            this.$refs.courseShareRef.show(item);
        },

        async ScrmQunguanExportTrainLessonStatistics(item) {
            const that = this;
            ScrmQunguanExportTrainLessonStatistics({
                train_lesson_id: item.train_lesson_id,
            }).then((r) => {
                that.$toast.success(r.msg);
                if (r.data.file_path_url) {
                    this.downloadCSV(r.data);
                }
            });
        },

        // 下载 CSV 文件
        async downloadCSV(item) {
            try {
                if (!item.file_path_url) {
                    this.$message.error("暂无下载链接，请重新生成");
                    return;
                }

                // 创建一个临时的 <a> 标签并触发点击
                const link = document.createElement("a");
                link.href = item.file_path_url; // 直接使用原始 URL
                link.download = item.file_title || "export.csv"; // 设置文件名
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (err) {
                console.error(err);
                this.$message.error("下载失败");
            }
        },
        onData: function (data = false) {
            console.log("data11", data);
            trainLessonDataStatistics({
                train_lesson_id: data.train_lesson_id,
            }).then((r) => {
                this.train_lesson_id = data.train_lesson_id;
                this.data_model = r.data;
            });
        },
        userDetails() {
            const item = JSON.parse(localStorage.getItem("userDetails"));
            if (item) {
                this.userDatalt = item;
            }
        },
        getCourseLessonList(e) {
            courseLessonList({ train_id: e + "" }).then((r) => {
                this.courses = r.data;
                // 退出编辑状态
                this.isEditing = false;
            });
        },
        // 初始化编辑表单
        initEditForm() {
            // 使用当前时间或默认值
            this.editForm.start_time = this.currentStartTime || "00:00:00";
            this.editForm.end_time = this.currentEndTime || "00:00:00";

            // 初始化时间选择器的值
            this.startTimeDate = this.currentStartTime || "00:00:00";
            this.endTimeDate = this.currentEndTime || "00:00:00";
        },
        // 切换编辑状态
        toggleEdit() {
            if (this.isEditing) {
                // 完成编辑，提交数据
                this.submitEdit();
            } else {
                this.isEditing = true;
                this.initEditForm();
            }
        },
        // 取消编辑
        cancelEdit() {
            this.isEditing = false;
            this.editForm.start_time = "";
            this.editForm.end_time = "";
        },
        // 开始时间选择确认（只选择时分秒）
        onStartTimeConfirm(timeStr) {
            // timeStr 格式为 "HH:mm:ss"
            this.editForm.start_time = timeStr;
            this.startTimeDate = timeStr;
        },
        // 结束时间选择确认（只选择时分秒）
        onEndTimeConfirm(timeStr) {
            // timeStr 格式为 "HH:mm:ss"
            this.editForm.end_time = timeStr;
            this.endTimeDate = timeStr;
        },
        // 提交编辑
        submitEdit() {
            // 验证数据
            if (!this.editForm.start_time) {
                Toast({ position: "top", message: "请选择开始时间" });
                return;
            }
            if (!this.editForm.end_time) {
                Toast({ position: "top", message: "请选择结束时间" });
                return;
            }

            // 验证时间格式
            const startTime = this.editForm.start_time;
            const endTime = this.editForm.end_time;

            // 比较时分秒
            const startSeconds = this.timeToSeconds(startTime);
            const endSeconds = this.timeToSeconds(endTime);

            if (startSeconds >= endSeconds) {
                Toast({ position: "top", message: "结束时间必须晚于开始时间" });
                return;
            }



            // 提交数据（需要完整的日期时间格式）
            const submitData = {
                train_id: this.selectedItem.train_id,
                train_start_time: `${this.editForm.start_time}`,
                train_end_time: ` ${this.editForm.end_time}`,
                train_red_money: this.editForm.red_money
            };

            updateTrainTimeRedMoneyConfig(submitData)
                .then((res) => {
                    if (res.code == 1) {
                        Toast.success("更新成功");
                        // 更新本地显示
                        this.currentStartTime = this.editForm.start_time;
                        this.currentEndTime = this.editForm.end_time;
                        // 更新课程列表中的时间
                        this.onActivePeriods(this.selectedItem)
                        // 退出编辑状态
                        this.isEditing = false;
                    } else {
                        Toast.fail(res.msg || "更新失败");
                    }
                })
                .catch((err) => {
                    console.error(err);
                    Toast.fail("更新失败，请重试");
                });
        },
        // 将时间字符串转换为秒数（用于比较）
        timeToSeconds(timeStr) {
            const parts = timeStr.split(":");
            if (parts.length >= 2) {
                const hours = parseInt(parts[0]) || 0;
                const minutes = parseInt(parts[1]) || 0;
                const seconds = parseInt(parts[2]) || 0;
                return hours * 3600 + minutes * 60 + seconds;
            }
            return 0;
        },
        onActivePeriods(item) {
            console.log(item);
            console.log("11111");
            this.selectedItem = item;
            if (this.selectedItem) {
                this.getTrainTimeRedConfig(this.selectedItem.train_id)
                this.getCourseLessonList(this.selectedItem.train_id);
            }
        },
        routerPush(e) {
            this.$router.push(e);
        },
    },
};
</script>

<style scoped lang="less">
.edit-time {
    background: #ffffff;
    border-radius: var(--base-px-8);
    padding: var(--base-px-16);
    margin-bottom: var(--base-px-16);

    .edit-time-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: var(--base-px-16);
    }

    .edit-time-title {
        font-size: var(--base-px-12);
        font-weight: bold;
        color: #333333;
    }

    .edit-time-actions {
        display: flex;
        gap: var(--base-px-10);
    }

    .edit-time-item {
        display: flex;
        align-items: center;
        margin-bottom: var(--base-px-12);
        font-size: var(--base-px-14);

        .time-label {
            color: #666666;
            min-width: var(--base-px-80);
        }

        .time-value {
            color: #333333;
            font-weight: 500;
        }

        .time-input-wrapper {
            flex: 1;
            margin-left: var(--base-px-10);
        }

        .time-input {
            padding: 0;
            height: var(--base-px-32);
            background: #f5f7f7;
            border-radius: var(--base-px-4);
        }
    }
}

.lesson-edit {
    width: var(--base-px-48);
    height: var(--base-px-24);
    background-color: #007aff;
    color: #ffffff;
    border-radius: var(--base-px-4);
    text-align: center;
    line-height: var(--base-px-24);
    font-size: var(--base-px-12);
    cursor: pointer;
}

.lesson-cancel {
    width: var(--base-px-48);
    height: var(--base-px-24);
    background-color: #f5f7f7;
    color: #666666;
    border-radius: var(--base-px-4);
    text-align: center;
    line-height: var(--base-px-24);
    font-size: var(--base-px-12);
    cursor: pointer;
}
</style>

<style scoped lang="less">
@wait: #45c400;
@over: #c8cad0;
@finsh: red;

/deep/ .van-tabbar {
    box-sizing: content-box !important;
}

/deep/ .have-matter-wait {
    &:before {
        background: @wait;
        position: absolute;
        z-index: 88;
        content: "";
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        bottom: var(--base-px--2);
        width: var(--base-px-5);
        height: var(--base-px-5);
        border-radius: 50%;
        margin-left: var(--base-px-1);
        //background: #c8cad0;
    }
}

/deep/ .have-matter-over {
    &:before {
        background: @finsh;
        position: absolute;
        z-index: 88;
        content: "";
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        bottom: var(--base-px--2);
        width: var(--base-px-5);
        height: var(--base-px-5);
        border-radius: 50%;
        margin-left: var(--base-px-1);
        //background: #c8cad0;
    }
}

/deep/ .have-matter-finsh {
    &:before {
        background: @over;
        position: absolute;
        z-index: 88;
        content: "";
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        bottom: var(--base-px--2);
        width: var(--base-px-5);
        height: var(--base-px-5);
        border-radius: 50%;
        margin-left: var(--base-px-1);
        //background: #c8cad0;
    }
}

/deep/ .hide-icon .van-radio__icon {
    visibility: hidden;
}

/deep/ .hide-icon .van-radio__label {
    width: var(--base-px-126);
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.index {
    font-size: var(--base-px-14);
    min-height: 100%;
    background-color: #f2f3f7;
    width: 100%;

    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .block {
        text-align: center;
        color: #ffffff;
        font-size: var(--base-px-12);
    }

    .course {
        padding: var(--base-px-12) 0 0 var(--base-px-12);

        &-l {
            width: var(--base-px-90);
            background: #ffffff;
            border-radius: var(--base-px-8) var(--base-px-8) var(--base-px-8) var(--base-px-8);
            font-weight: 400;
            font-size: var(--base-px-14);
            line-height: var(--base-px-16);
            text-align: center;
            font-style: normal;
            text-transform: none;
            padding: var(--base-px-4);
            overflow-y: scroll;

            &-item {
                padding: var(--base-px-12) 0;
                color: #333333;
                line-height: var(--base-px-20);
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                text-align: center;

                &-selected {
                    color: #1a89f9;
                }
            }
        }

        &-l {

            /* 隐藏进度条 */
            ::-webkit-scrollbar {
                display: none;
            }

            -ms-overflow-style: none;
            scrollbar-width: none;
        }

        &-r {
            width: calc(100% - var(--base-px-90));
            padding: 0 var(--base-px-12) 0 var(--base-px-12);
            overflow: auto;

            &-item {
                height: var(--base-px-80);
                background: #ffffff;
                border-radius: var(--base-px-8) var(--base-px-8) var(--base-px-8) var(--base-px-8);
                margin-top: var(--base-px-12);
                padding: var(--base-px-6);

                &:first-of-type {
                    margin-top: 0;
                }

                &-l {
                    width: var(--base-px-100);
                    height: var(--px-56);
                    position: relative;

                    img {
                        width: 100%;
                        height: 100%;
                        //border-radius: var(--base-px-8);
                    }
                }

                &-r {
                    width: calc(100% - var(--base-px-110));
                    height: 100%;
                    padding: var(--base-px-10) 0 var(--base-px-10) var(--base-px-12);

                    &-top {
                        font-weight: bold;
                        font-size: var(--base-px-14);
                        color: #333333;
                        line-height: var(--base-px-16);
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                        overflow: hidden;
                        height: var(--base-px-35);
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 3;
                        /* 限制显示行数 */
                        overflow: hidden;
                        /* 隐藏溢出内容 */
                        word-break: break-word;
                        /* 处理长单词或URL换行 */
                    }

                    &-bottom {
                        font-weight: 400;
                        font-size: var(--base-px-12);
                        color: #333333;
                        line-height: var(--base-px-16);
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                        //margin-top: var(--base-px-13);
                    }
                }
            }
        }
    }

    .tab {
        justify-content: space-between;
        //img {
        //	width: var(--base-px-22);
        //	height: var(--base-px-22);
        //}
    }
}

.es {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    position: relative;
}

.es-ver {
    flex-direction: column;
}

.es-ac {
    align-items: center;
}

.es-ae {
    align-items: flex-end;
}

.es-pc {
    justify-content: center;
}

.es-pe {
    justify-content: flex-end;
}

.es-f1 {
    flex-grow: 1;
}

.es-f2 {
    flex-grow: 2;
}

.es-f3 {
    flex-grow: 3;
}

.es-f4 {
    flex-grow: 4;
}

.es>div,
.es>div {
    flex-shrink: 0;
}

.es-f1,
.es-f2,
.es-f3,
.es-f4 {
    flex-shrink: 1 !important;
    overflow: hidden;
}

.es-block {
    position: relative;
    overflow: hidden;
}

.es-block>div:nth-child(1) {
    padding-top: 100%;
    width: 100%;
}

.es-block>div:nth-child(2) {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    overflow: hidden;
    z-index: 1;
}

.es-block>div:nth-child(3) {
    position: absolute;
    overflow: hidden;
    z-index: 2;
}

.es-omit,
.es-omit-1 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.data-model-item {
    height: var(--base-px-20);
    border-radius: var(--base-px-8);
    margin: var(--base-px-3);
}

.data-model-item-ac {
    background-color: white;
    color: #1a89f9;
}

/deep/ .van-field__body {
    height: 100%;
    padding-left: 10px;
}
</style>
